//
// Copyright (c) 2011-2025 by Curalate, Inc.
//
import styled from 'styled-components';

import Icon from '@components/atoms/icon/Icon';

export const HarmonyAIIcon = styled(Icon).attrs({
  name: 'sparkles',
})`
  path:nth-child(1) {
    fill: #329e9b;
  }

  path:nth-child(2) {
    fill: #ffd10d;
  }

  path:nth-child(3) {
    fill: #f7911e;
  }
`;

export const DisabledHarmonyAIIcon = styled(Icon).attrs({
  name: 'sparkles',
})(
  ({ theme }) => `
  color: ${theme.colors.aliases.disabled};
`,
);

export const WhiteHarmonyAIIcon = styled(Icon).attrs({
  name: 'sparkles',
})(
  ({ theme }) => `
  color: ${theme.colors.white};
`,
);

export const PrimaryHarmonyAIIcon = styled(Icon).attrs({
  name: 'sparkles',
})(
  ({ theme }) => `
  color: ${theme.colors.aliases.primary};
`,
);

export const BodyPrimaryHarmonyAIIcon = styled(Icon).attrs({
  name: 'sparkles',
})(
  ({ theme }) => `
  color: ${theme.colors.aliases.bodyPrimary};
`,
);
